import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { MdAutorenew } from "react-icons/md";
import { toast } from "react-toastify";
import LoaderButton from "../components/LoaderButton";
import { Constants } from "../libs/Constants";
import { create, getList, update } from "../libs/dbFunctions";
import { convertDate, getCurrentDate, getValidDate } from "../libs/utils";
import "./PlanSignUp.css";

export default class PlanSignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      periodStartdate: "",
      periodEnddate: "",
      acceptTerms: "off",
      updateSuccess: null,
      hasValidPeriod: false,
      enrollStartdate: "",
      enrollEnddate: "",
      periodFound: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentWillMount() {
    let currentDate = getCurrentDate();
    let dateDiffArray = [];
    try {
      //fetch the period rows from database
      const periodDetails = await getList(
        Constants.dbTypes.PERIOD,
        this.props.activeCompany
      );
      if (periodDetails && periodDetails.length > 0) {
        periodDetails.map((period) => {
          let period_startdate = getValidDate(period.periodStartdate);
          dateDiffArray.push(
            Math.abs(currentDate.diff(period_startdate, "days"))
          );
        });
        const nearestPeriod = dateDiffArray.indexOf(
          dateDiffArray.reduce((a, b) => Math.min(a, b))
        );
        let enrollSDate = getValidDate(
          periodDetails[nearestPeriod].enrollmentStartDate
        );
        let enrollEDate = getValidDate(
          periodDetails[nearestPeriod].enrollmentEndDate
        );
        let hasValidPeriod = false;
        if (currentDate.isBetween(enrollSDate, enrollEDate))
          hasValidPeriod = true;
        this.setState({
          periodStartdate: getValidDate(
            periodDetails[nearestPeriod].periodStartdate
          ),
          periodEnddate: getValidDate(
            periodDetails[nearestPeriod].periodEnddate
          ),
          enrollStartdate: enrollSDate,
          enrollEnddate: enrollEDate,
          isLoading: false,
          periodFound: true,
          hasValidPeriod: hasValidPeriod,
        });
      } else {
        this.setState({
          isLoading: false,
          periodFound: false,
          hasValidPeriod: false,
        });
      }
    } catch (e) {
      toast.error(e);
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  async handleSubmit(event) {
    event.preventDefault();
    //create Contribution Record for the user
    let contributionObject = {
      periodStartdate: this.state.periodStartdate,
      periodEnddate: this.state.periodEnddate,
      currentUser: this.props.userObj.id,
      companyId: this.props.activeCompany.id,
    };
    this.setState({ isLoading: true });
    try {
      console.log("creating Object:" + JSON.stringify(contributionObject));
      await create(Constants.dbTypes.CONTRIBUTION, contributionObject);

      //update user details
      let terms = false;
      if (this.state.acceptTerms === "on") terms = true;
      let obj = Object.assign({
        ...this.props.userObj,
        ["acceptTerms"]: terms,
      });

      console.log("creating Object:" + JSON.stringify(obj));
      await update(Constants.dbTypes.USER, obj);
      this.props.setUserObj(obj);

      this.setState({
        updateSuccess: true,
        isLoading: false,
      });
      this.props.history.push("/");
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  }
  renderEffectiveDate() {
    return (
      <div>
        Effective:{" "}
        {convertDate(this.state.periodStartdate, Constants.DATEFORMAT.MMDDYYYY)}
      </div>
    );
  }
  renderNoPeriodMsg() {
    if (!this.state.periodFound) {
      return <div>No Valid Period available.Contact your Adminstrator! </div>;
    } else {
      return (
        <div>
          Enrollment allowed between
          {convertDate(
            this.state.enrollStartdate,
            Constants.DATEFORMAT.MMDDYYYY
          )}
          -
          {convertDate(this.state.enrollEnddate, Constants.DATEFORMAT.MMDDYYYY)}{" "}
        </div>
      );
    }
  }

  render() {
    return (
      <div className="container p5">
        {this.state.isLoading && <MdAutorenew className="spinning" />}
        {!this.state.isLoading && (
          <div className="container center">
            <h1 className="mb12">Contribute with Taabl</h1>
            <Form onSubmit={this.handleSubmit} className="text-center">
              <Form.Group
                controlId="acceptTerms"
                size="lg"
                className={`form-group`}
              >
                <Form.Check
                  type="checkbox"
                  name="terms"
                  id="acceptTerms"
                  className="pl5"
                >
                  <Form.Check.Input
                    type="checkbox"
                    onChange={this.handleChange}
                  />
                  <Form.Check.Label>
                    I agree to the <a href=""> Terms and Conditions </a>
                  </Form.Check.Label>
                </Form.Check>
              </Form.Group>
              {this.state.periodFound && this.renderEffectiveDate()}
              {!this.state.hasValidPeriod && this.renderNoPeriodMsg()}
              <LoaderButton
                size="lg"
                className="mt3"
                id="submit"
                block
                variant="success"
                disabled={
                  this.state.acceptTerms !== "on" || !this.state.hasValidPeriod
                }
                isLoading={this.state.isLoading}
                onClick={this.handleSubmit}
              >
                Submit
              </LoaderButton>
              <div>Having trouble deciding?</div>
              <div>
                <a>Learn more about Taabl HERE!</a>
              </div>
            </Form>
          </div>
        )}
      </div>
    );
  }
}
